import React, { useContext, useLayoutEffect } from 'react'
import { useLoaderData } from 'react-router-dom'
import { useMutation, useClient } from 'urql'
import UserContext from '../../../context/UserContext'
import { UpdateEnrolmentInterestsMutation } from '../../../graphql/documents'
import useDisplayError from '../../../hooks/useDisplayError'
import PageNavContainer from '../../../state/PageNavContainer'
import OnboardingInterestsPage from './OnboardingInterestsPage'
import { RoutingQuery } from '../../../graphql/documents'
import RoutingContext from '../../../context/RoutingContext'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const PAGE_ID = `onboarding-interests`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const OnboardingInterestsModule = () => {
  const [, setNav] = PageNavContainer.useContainer()
  const loaderData = useLoaderData()
  const { displayError } = useDisplayError()
  const { currentEnrolment } = useContext(UserContext)
  const { appRouting } = useContext(RoutingContext)
  const client = useClient()
  const [, updateEnrolmentInterests] = useMutation(
    UpdateEnrolmentInterestsMutation
  )

  useLayoutEffect(() => {
    setNav({
      pageId: PAGE_ID,
      backgroundIsHidden: true,
      accoundNavIsHidden: true,
    })
  }, [setNav])

  const { id: enrolmentId } = currentEnrolment

  const handleSubmitInterests = async (interests) => {
    const { error } = await updateEnrolmentInterests({ 
      params: { enrolmentId, interests } 
    })
    
    if (error) {
      displayError(
        loaderData.page.content.failedSubmissionErrorMessage,
        error,
        { isFatal: false }
      )
    } else {
      // Fetch fresh routing data
      const result = await client.query(RoutingQuery, {}, { 
        requestPolicy: 'network-only' 
      }).toPromise()
      
      const homePath = result.data?.routing?.homePath || appRouting.homePath
      
      window.location.href = homePath
    }
  }

  return (
    <OnboardingInterestsPage
      pageContent={loaderData.page.content}
      onSubmitInterests={handleSubmitInterests}
    />
  )
}

export default OnboardingInterestsModule
